import { tolgee } from "@/providers/TranslationProvider";

export const getDropfileErrorMessage = (
  errorMessage: string | undefined
): string | undefined => {
  if (!errorMessage) {
    return undefined;
  }

  switch (errorMessage) {
    case "dropfile.errorDropfileType":
      return tolgee.t("dropfile.errorDropfileType");
    case "cardAddDeliveryNote.deliveryNote.errorDropfile":
      return tolgee.t("cardAddDeliveryNote.deliveryNote.errorDropfile");
    case "cardAddDeliveryNote.deliveryNote.errorDropfileType":
      return tolgee.t("cardAddDeliveryNote.deliveryNote.errorDropfileType");
    case "order.catalogMediumConfiguration.stepVersions.errorDropfile":
      return tolgee.t(
        "order.catalogMediumConfiguration.stepVersions.errorDropfile"
      );
    case "order.catalogMediumConfiguration.stepVersions.errorNoFileOutput":
      return tolgee.t(
        "order.catalogMediumConfiguration.stepVersions.errorNoFileOutput"
      );
    default:
      return errorMessage;
  }
};
